<template>
  <v-row class="chat-detail">
    <v-col cols="12">
      <div class="chat-header" style="background: white;color: black">
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="8" v-on:click="goToInfo(user_info)" v-if="appear_name">
            <div class="flex">
              <img :src="user_info.ThumbPath"/>
              <div>
                <span class="name" style="color: black;font-size: 13px" v-if="group_flag == false">
                  {{ user_info.Name }}
                </span>
                <span class="name" style="color: black;font-size: 13px" v-if="group_flag == true">
                  {{ user_info.GroupName }}
                </span>
                <span v-if="typing_text==''" style="color: black;font-size: 12px" class="last-seen">

                  {{ user_info.LastSeenDate }}
                </span>
                <span v-if="typing_text!=''" style="color: black;font-size: 12px" class="last-seen">

                  {{ typing_text }}
                </span>
              </div>

            </div>
          </v-col>
          <div class="col-4" v-if="!appear_name">

          </div>

          <div class="col-1 padding-12-0 text-center" v-if="!appear_name">
              <span class="reply-btn" @click="reply()" v-if="header_reply">
               <v-icon style="color:black">
                mdi-reply
              </v-icon>
            </span>
          </div>
          <div class="col-2 text-center" v-if="!appear_name">
            <span class="trash-btn " @click="deleteSelected()">
               <v-icon style="color:black">
                mdi-delete
              </v-icon>
            </span>
          </div>
          <div class="col-1 padding-12-0 text-center" v-if="!appear_name">
            <span class="share-btn" @click="forwardSelected()">
               <v-icon style="color:black">
                mdi-share
              </v-icon>
            </span>
          </div>

          <div class="col-2">
            <span class="back-btn" style="color: black" @click="backToChats()">
               <v-icon style="color:black">
                mdi-arrow-left
              </v-icon>
            </span>
          </div>
          <div class="col-1"></div>

          <!--          <div class="col-1"></div>-->
        </v-row>
      </div>

    </v-col>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      width="100%"
    >
      <v-card class="edit-picture blue-border">
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

        </v-toolbar>

        <v-card-text>

          <div class="full-screen-photos">
            <img :src="open_image"/>
          </div>
          <!--            <div v-for="item in photos" class="full-screen-photos">-->
          <!--              <img :src="item.ImageUrl" />-->
          <!--            </div>-->

        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_camera"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog_camera = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('camera') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="downloadImage()"
            >
              {{ $t('save') }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div v-if="isCameraOpen" class="camera-box">
          <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>
          <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
        </div>
        <div v-if="isCameraOpen" class="camera-shoot">
          <v-btn type="button" class="button" @click="takePhoto">
            <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
          </v-btn>
        </div>
        <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
          <!--            <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">-->
          <!--              Download-->
          <!--            </a>-->
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_location"
      fullscreen
      hide-overlay
      style="overflow:auto;"
    >
      <v-card class="edit-picture blue-border">
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog_location = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="save_location()"
            >
              {{ $t('send') }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div>
          <div ref="map"  id="map2" class="basemap"></div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_record"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="edit-picture blue-border">
        <v-toolbar
          dark
          color="primary">
          <v-btn
            icon
            dark
            @click="dialog_record = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="save_location()"
            >
              {{ $t('save') }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div id="controls">
            <button id="recordButton" v-on:click="startRecording()">Record</button>
            <button id="pauseButton" disabled>Pause</button>
            <button id="stopButton" disabled>Stop</button>
          </div>
          <h3>Recordings</h3>
          <ol id="recordingsList"></ol>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-col cols="12">
      <div class="chat-text"  id="chat_detail" v-chat-scroll="{always: false}"
           style="background-image: url('/img/chat-bg.svg');calc(100vh - 160px);overflow: auto">
        <infinite-loading @infinite="infiniteHandler" direction="top">
          <div slot="no-more"></div>
          <template slot="no-results">{{ $t('noResult') }}</template>
          <template slot="spinner">{{ $t('loading') }}</template>

        </infinite-loading>
        <div class="chat-contents">
          <!--         <div v-for="(chat , i) in chatLoad" v-on:click="selectChat(chat , i)" @contextmenu="openMenu($event, chat , i)">-->
          <div v-for="(chat , i) in chatLoad" v-on:click="checkOneClick($event, chat , i)"
               @contextmenu="longClick($event,chat, i)">
            <div class="your-message "  style="display: inline-flex"  v-if="chat.UserSenderId != UserId"
                 v-bind:class="{'is-select': chat.IsSelected ,'fully': chat.Attachments.length > 0 }">
              <div v-if="RecTypeId==1" ><img  style="width: 40px;
    border-radius: 45px;" :src="chat.UserSenderThumbnail"></div>
              <div class="inner">

                <div v-if="chat.Attachments.length > 0">
                  <div v-for="att in chat.Attachments" v-if="chat.Attachments.length == 1 && att.DocType == 3">
                    <img :src="att.DocUrl" class="attachment-img" v-on:click="openImg(att.DocUrl)"/>
                  </div>

                  <!----------------for imaged-------------->

                  <div v-if="chat.Attachments.length > 1 && att.DocType == 3" class="multi-attach"
                       v-for="att in chat.Attachments" @click="openLink(att.DocType ,att.DocUrl)">
                    <img :src="att.DocUrl" class="attachment-img" v-on:click="openImg(att.DocUrl)"
                         v-if="att.DocType == 3"/>
                    <span v-if="att.DocType == 1" class="attach-icon" @click="openLink(att.DocUrl)">
                     <v-icon>
                       mdi-link
                     </v-icon>
                   </span>
                    <span v-if="att.DocType == 5" class="attach-icon">
                     <v-icon>
                       mdi-music-note
                     </v-icon>
                   </span>

                    <div class="text-center attach-name"
                         v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null ">
                      {{ att.Caption }}
                    </div>
                    <div class="text-center attach-name" dir="ltr" v-if="att.Caption == ' ' && att.DocType == 3">
                      {{ att.Image_Name }}
                    </div>

                  </div>

                  <!-----------------for other type--------->

                  <div v-if=" att.DocType != 3" class="multi-attach" v-for="att in chat.Attachments"
                       @click="openLink(att.DocType ,att.DocUrl)">
                   <span v-if="att.DocType == 1" class="attach-icon" @click="openLink(att.DocUrl)">
                     <v-icon>
                       mdi-link
                     </v-icon>
                   </span>
                    <span v-if="att.DocType == 5" class="attach-icon">
                     <v-icon>
                       mdi-music-note
                     </v-icon>
                   </span>
                    <span v-if="att.DocType == 2" class="attach-icon">
                     <v-icon>
                       mdi-file
                     </v-icon>
                   </span>
                    <!--                  <span v-if="att.DocType == 7" class="attach-icon">-->
                    <!--                      <a :href="`tel:+${ att.DocUrl.split('*')[0] }`" class="attach-icon-link">-->
                    <!--                         <v-icon>-->
                    <!--                           mdi-account-box-outline-->
                    <!--                         </v-icon>-->
                    <!--                       </a>-->
                    <!--                   </span>-->
                    <span v-if="att.DocType == 4" class="attach-icon">
                     <v-icon>
                       mdi-map-marker
                     </v-icon>
                   </span>
                    <span v-if="att.DocType == 6" class="attach-icon">
                     <v-icon>
                       mdi-video-outline
                     </v-icon>
                   </span>
                    <div>
                      <!--                    <div class="text-center attach-name" v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null ">-->
                      <!--                    <div class="text-center attach-name" v-if="att.Caption != ' ' && att.DocType == 7">-->
                      <!--                      <a :href="`tel:+${ att.DocUrl.split('*')[0] }`">-->
                      <!--                        {{ att.Caption }}-->
                      <!--                      </a>-->
                      <!--                    </div>-->
                      <div class="text-center attach-name" v-if="att.Caption != ' ' && att.DocType != 7">
                        {{ att.Caption }}
                      </div>

                      <div class="text-center attach-name" dir="ltr" v-if="att.Caption == ' ' && att.DocType == 1">
                        {{ att.Image_Name }}
                      </div>
                      <div class="audio-msg" v-if="att.DocType == 5">
                        <vuetify-audio :file="att.DocUrl" color="success"></vuetify-audio>
                      </div>
                    </div>

                  </div>

                </div>
                <p v-if="RecTypeId==1" class="text" style="margin-bottom: 0px;
    font-size: 12px;
    color: #0568bd;" :id="'chat_text_name'+ i">
                  {{ chat.UserSenderName }}
                </p>
                <span class="text" :id="'chat_text_'+ i">
                 {{ chat.MessageText }}
                </span>
                <div class="deliver">
                  {{ get_conversation_date(chat) }}
                </div>
              </div>

            </div>
            <div class="my-message"   v-if="chat.UserSenderId == UserId"
                 v-bind:class="{'is-select': chat.IsSelected ,'fully': chat.Attachments.length > 0 }">
              <div class="inner">
                <!--{{chat.UserSenderId }} {{UserId}} {{GetSender}}-->
                <div v-if="chat.Attachments.length > 0">
                  <div v-for="att in chat.Attachments">
                    <div v-if='chat.Attachments.length == 1 && att.DocType==3'>
                      <img :src="att.DocUrl" class="attachment-img" v-on:click="openImg(att.DocUrl)"/>
                      <div class="text-center attach-name"
                           v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null">
                        {{ att.Caption }}
                      </div>
                      <div class="text-center attach-name"
                           v-if="att.Caption == ' ' || att.Caption == '' || att.Caption == null">
                        {{ att.Image_Name }}
                      </div>
                    </div>
                    <span class="multi-attach" v-else>
                  <a :href="att.DocUrl" class="attachment-img" v-if="att.DocType==2" download>
                      <v-icon>
                          mdi-file
                      </v-icon>
                    </a>
                    <img :src="att.DocUrl" class="attachment-img" v-if="att.DocType==3"
                         v-on:click="openImg(att.DocUrl)"/>
                    <span :src="att.DocUrl" class="attachment-img" v-if="att.DocType==5"
                          v-on:click="openImg(att.DocUrl)">
                      <audio controls >
  <source :src="att.DocUrl" type="audio/ogg">
Your browser does not support the audio element.
</audio>
                      <v-icon>
                          mdi-file
                      </v-icon>
                    </span>
                     <span :src="att.DocUrl" class="attachment-img" v-if="att.DocType==6"
                           v-on:click="openImg(att.DocUrl)">
                      <v-icon>
                          mdi-file
                      </v-icon>
                    </span>
                     <div  class="attachment-img" v-if="att.DocType==4"
                           v-on:click="openMap(att.DocUrl)">
                      <img src="/img/location_icon.svg"/>
                    </div>

                    <div class="text-center attach-name"
                         v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null">
                      {{ att.Caption }}
                    </div>
                    <div class="text-center attach-name"
                         v-if="att.Caption == ' ' || att.Caption == '' || att.Caption == null">
                      {{ att.Image_Name }}
                    </div>
                  </span>
                  </div>
                  <!--                <div v-if="chat.Attachments.length > 1 && chat.Attachments.DocType==3" class="multi-attach" v-for="att in chat.Attachments">-->
                  <!--                  <img :src="att.DocUrl" class="attachment-img" v-if="att.DocType==3" v-on:click="openImg(att.DocUrl)"/>-->
                  <!--                  <div class="text-center attach-name" v-if="att.Caption != ' ' && att.Caption != '' && att.Caption != null">-->
                  <!--                    {{ att.Caption }}-->
                  <!--                  </div>-->
                  <!--                  <div class="text-center attach-name" v-if="att.Caption == ' ' || att.Caption == '' || att.Caption == null">-->
                  <!--                    {{ att.Image_Name }}-->
                  <!--                  </div>-->

                  <!--                </div>-->

                </div>
                <span class="text" :id="'chat_text_'+ i" :value="chat.MessageText">
                {{ chat.MessageText }}
               </span>
                <div class="deliver">
                 <span>
                   <v-icon v-if="chat.status==10">
                     mdi-check-all
                   </v-icon>
                   <v-icon v-if="chat.status==5">
                     mdi-check
                   </v-icon>
                   <v-icon v-if="chat.status==1">
                     mdi-clock-outline
                   </v-icon>
                 </span>
                  {{ get_conversation_date(chat) }}
                </div>
              </div>

            </div>

            <v-menu
              v-model="showMenu"
              :position-x="x"
              :position-y="y"
              absolute
              offset-y
            >
              <v-list v-if="hide_menu">

                <v-list-item @click="reply()">
                  <v-list-item-title>
                    <span>{{ $t('reply') }}</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title @click="copyMsg($event)">
                      <span id="mymsg">
                        {{ $t('textCopy') }}
                      </span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <div class="chat-input-box-outer">

          <picker v-model="text" v-show="showEmojiPicker" @select="addEmoji" set="apple"/>

          <div class="chat-input-box">
            <div class="attach-tags">
            <span v-for="item in files" class="tag">
<!--                <img :src="item.file" v-if="ImageOrNot(item.name) item.name.split('.')[1]=='.jpg'||item.name.split('.')[1]=='.png'||item.name.split('.')[1]=='.PNG'||item.name.split('.')[1]=='.jpeg'||item.name.split('.')[1]=='.JPEG'"/>-->
                <img :src="item.file" v-if="ImageOrNot(item.name)"/>
                <span v-else>
                  <v-icon>
                    mdi-file
                  </v-icon>
                </span>
                <span class="tag-name">
                    {{item.name}}
                </span>
                <v-icon v-on:click="deleteTag(item)">
                    mdi-close
                </v-icon>
            </span>
            </div>
            <label style="color:white" v-if="recording_time!=0">{{second_human(recording_time)}}</label>
            <div class="open-attach" v-if="attach_flag">
              <audio id="audioElement"></audio>

              <div class="row" style="background: white;border-radius: 5px;padding: 10px;">

                <div class="col" style="text-align: center;">
                  <button class="position-relative">
                    <img src="/img/gallery_icon.svg"/>
                    <p>{{ $t('file') }}</p>
                    <input type="file" name="file" class="attach-input"  id="fileUpload" @change="onFileChange('file')"/>
                  </button>

                </div>
                <!--            <div class="col">-->
                <!--              <button class="position-relative" v-on:click="openCamera()">-->
                <!--                <img src="../../assets/messenger/messenger_attach_camera.png" />-->
                <!--                &lt;!&ndash;                  <input type="file" name="file" class="attach-input"  @change="onFileChange($event ,'camera')"/>&ndash;&gt;-->
                <!--              </button>-->
                <!--            </div>-->

                <div class="col" style="text-align: center;">
                  <button class="position-relative" v-on:click="open_map">
                    <img src="/img/location_icon.svg"/>
                    <p>{{ $t('map') }}</p>

                  </button>

                </div>
                <div class="col">
                </div>
                <div class="col">
                  <!--              <button class="position-relative" v-on:click="startRecording()">-->
                  <!--                <img src="../../assets/messenger/messenger_attach_microphone.png" />-->
                  <!--                &lt;!&ndash;                  <input type="file" name="file" class="attach-input" />&ndash;&gt;-->
                  <!--                <audio ref="audio" hidden></audio>-->
                  <!--              </button>-->

                </div>

              </div>
            </div>
            <div class="reply" v-if="reply_flag">
             <span class="reply-text">
                {{ reply_item.MessageText }}
             </span>
              <span class="close-reply" @click="reply_flag = false">
               <v-icon>
                 mdi-close
               </v-icon>
             </span>

            </div>
            <div class="chat-input-box-inner">
              <div v-if="chat_text!='' || files.length>0" class="send-btn" v-on:click="send_msg()">
                <v-icon class="second-send">
                  mdi-send
                </v-icon>
              </div>
              <div v-if="chat_text=='' && files.length==0" class="send-btn " @touchstart="startRecording"
                   @touchend="stopRecording" @mousedown="startRecording" @mouseup="stopRecording"
                   id="microphone_record_btn">
                <v-icon class="second-send">
                  mdi-microphone
                </v-icon>
              </div>
              <div style="width: 100%;
    display: inline-flex;background: white;border-radius: 45px">
                <div class="plus-btn" v-on:click="openAttach()">
                  <v-icon style="transform: rotate(45deg)">
                    mdi-paperclip
                  </v-icon>
                </div>

                <!--                <div class="plus-btn" v-on:click="openCamera()">-->
                <!--                  <img style="width: 20px;" src="/img/camera_icon.svg"/>-->
                <!--                  <input type="file" name="file" class="attach-input" accept="image/*" capture="camera" id="fileUploadCamera" @change="onFileChangeCamera('file')"/>-->

                <!--                </div>-->
                <div class="plus-btn" @click="open_camera_input()">
                  <img style="width: 20px;" src="/img/camera_icon.svg"/>
                  <input style="display: none" type="file" name="file" class="attach-input" accept="image/*" capture="camera" id="fileUploadCamera" @change="onFileChangeCamera('file')"/>

                </div>

                <input :placeholder="$t('writeYourMessage')"
                       :value="chat_text"
                       @input="e => chat_text = e.target.value"
                       v-on:click="closeClick()"/>
                <button class="emoji-trigger" @click="toggleEmojiPicker">
                  <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path
                      d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
                  </svg>
                </button>
              </div>

            </div>

          </div>

        </div>

      </div>

    </v-col>

  </v-row>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import { bus } from '../../main.js'

  // import VueContext from 'vue-context';
  // import 'vue-context/src/sass/vue-context.scss';
  // import TextareaEmojiPicker from '../../components/TextareaEmojiPicker.vue'
  import { Picker } from 'emoji-mart-vue'
  import { Emoji } from 'emoji-mart-vue'
  import Vue from 'vue'
  import mapboxgl from 'mapbox-gl'

  export default {
    data () {
      return {
        map: null,
        marker: null,
        dialog_location: false,
        dialog_record: false,
        dialog_camera: false,
        isCameraOpen: false,
        isPhotoTaken: false,
        attach_flag: false,
        showEmojiPicker: false,
        dialog: false,
        items: '',
        // show_loading: false,
        UserId: '',
        GetSender: '',
        UserGroupId: '',
        RecTypeId: '',
        chat_text: '',
        chat: [],
        password: '',
        up: 0,
        lastMessageId: 0,
        UserName: '',
        chats: [],
        user_info: '',
        first: true,
        chatLoad: [],
        group_flag: false,
        user_flag: false,
        text: '',
        selectedItem: [],
        emojies: '',
        appear_name: true,
        reply_flag: false,
        forward_message: [],
        show_detail: '',
        source_sender_id: 0,
        showMenu: false,
        x: 0,
        y: 0,
        reply_item: '',
        copy_text: '',
        last_select_index: '',
        header_reply: false,
        current_is_typing: 0,
        hide_menu: true,
        open_image: '',
        mobile: '8001234567',
        // image_name: '',
        split_result: [],
        typing_text: '',
        tagArray: [],
        tagFlag: false,
        files: [],
        user_location_lat: 0,
        user_location_lng: 0,
        rest: [],
        accessToken: 'pk.eyJ1Ijoiem9vZGtvbWFrIiwiYSI6ImNrOG1vYzVocjAxNm4zbWx2Zmk0bmJ1cHUifQ.rHAeQHubqjcMQTY2eQS1nA',

        user_addresses: [],
        mediaRecorder: null,
        chunks: [],
        audioURL: '',
        recording_time: 0,
        recording_timer: null,
      }
    },
    beforeDestroy () {
      bus.$off('signalr_methods', this.listener)
    },
    mounted () {
      // this.configRecording()
      mapboxgl.accessToken = this.accessToken
      try {
        mapboxgl.setRTLTextPlugin(
          'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
          null,
          true // Lazy load the plugin
        )
      } catch (e) {

      }

      var user_data = JSON.parse(localStorage.getItem('profile'))
      console.log('useeeer ' + JSON.stringify(user_data))
      this.password = localStorage.getItem('password')
      this.UserId = user_data.UserId
      this.UserName = user_data.UserName
      this.GetSender = localStorage.getItem('userId2')
      this.items = JSON.parse(localStorage.getItem('lastChat'))
      // console.log("lastChat " + JSON.stringify(this.items));
      this.UserGroupId = this.items.UserOrGroupId
      this.RecTypeId = this.items.RecType
      this.GetReceiver = this.items.GetReceiver
      console.log('UserOrGroupId', this.items.UserOrGroupId)
      this.forward_message = JSON.parse(localStorage.getItem('lastForward'))
      localStorage.setItem('lastForward', null)

      this.loadChats()

      if (this.items.RecType == 0) {
        this.getUserInfo()
        this.group_flag = false
        this.user_flag = true
      } else {
        this.getGroupInfo()
        this.group_flag = true
        this.user_flag = false
      }
      this.scrollToEnd()
      bus.$on('signalr_methods', (data) => {
        // console.log(this.GetReceiver)
        // console.log(data[1].sender)
        // console.log(data)
        //* *****************************************

        if (data[0] == 'is_typing' && data[1].sender == this.GetReceiver) {
          if (data[1].isTyping == 1) {
            this.typing_text = this.$t('is_typing')
          } else {
            this.typing_text = ''
          }
        }
        //* *****************************************

        if (data[0] == 'is_typing' && data[1].sender == this.GetReceiver) {
          if (data[1].isTyping == 1) {
            this.typing_text = this.$t('is_typing')
          } else {
            this.typing_text = ''
          }
        }
        //* *****************************************

        if (data[0] == 'read_message' && data[1].receiverId == this.GetReceiver) {
          console.log('read messages')
          this.chatLoad.filter(x => x.InboxItemId <= data[1].lastId).forEach(function (val) {
            val.status = 10
          })
        }
        //* ***********************************
        if (data[0] == 'get_message') {
          // console.log("received", data[1].CurrentUserId, this.GetReceiver, this.GetSender)

          if (data[1].CurrentUserId == this.GetSender) {
            // console.log(" my message received")
            // console.log(" chats ", JSON.stringify(this.chatLoad))

            for (var i = this.chatLoad.length - 1; i >= this.chatLoad.length - 10; i--) {
              if (data[1].UserDbId == this.chatLoad[i].userDbId) {
                if (this.chatLoad[i].userDbId != 'undefined') {
                  var message_obj = {
                    InboxItemId: data[1].InboxItemId,
                    SubmitDateTime: data[1].SubmitDateTime,
                    SubmitDateTimeMiladi: data[1].SubmitDateTimeEn,
                    UserSenderId: data[1].CurrentUserId,
                    UserSenderName: data[1].UserName,
                    SourceItem: data[1].SourceItem,
                    SendStatus: data[1].SendStatus,
                    SourceText: data[1].SourceText,
                    SourceSenderName: data[1].SourceSenderName,
                    SourceSenderId: data[1].SourceSenderId,
                    UserSenderThumbnail: data[1].Thumbnail,
                    ReceiverId:this.UserOrGroupId,
                    status: 5,

                    MessageText: data[1].Message,
                    Attachments: data[1].Attachments,
                    UserDbId: data[1].UserDbId,
                    Robot: data[1].Robot
                  }
                }
                console.log('my message received', message_obj)
                message_obj.UserSenderId = this.UserId
                this.chatLoad.splice(i, 1, message_obj)
                // this.chatLoad.push(message_obj);
              }
            }
          }
          // Vue.set(val, 'MessageText', data[1].Message)
          if (data[1].CurrentUserId == this.GetReceiver) {
            var message_obj = {
              InboxItemId: data[1].InboxItemId,
              SubmitDateTime: data[1].SubmitDateTime,
              SubmitDateTimeMiladi: data[1].SubmitDateTimeEn,
              UserSenderId: data[1].CurrentUserId,
              UserSenderName: data[1].UserName,
              SourceItem: data[1].SourceItem,
              SendStatus: data[1].SendStatus,
              SourceText: data[1].SourceText,
              SourceSenderName: data[1].SourceSenderName,
              SourceSenderId: data[1].SourceSenderId,
              UserSenderThumbnail: data[1].Thumbnail,
              ReceiverId: this.UserId,
              MessageText: data[1].Message,
              UserDbId: data[1].UserDbId,
              Attachments: data[1].Attachments,
              Robot: data[1].Robot
            }
            this.chatLoad.push(message_obj)

            var data = {
              ReceiverId: this.UserId,
              SenderId: this.items.UserOrGroupId,
              LastItemId: message_obj.InboxItemId
            }
            var obj = { method: 'send_read', data: JSON.stringify(data) }
            bus.$emit('signalr_invokes', JSON.stringify(obj))
          }
        }
        //* ***********************************
        // setTimeout(this.load = name , 1000)
      })
    },

    watch: {
      chat_text: function () {
        var is_typing = 1

        if (this.chat_text == '') {
          is_typing = 0
        }
        // console.log('is_typing send',this.user_info);
        if (this.current_is_typing != is_typing) {
          var data = {
            sender: this.UserId,
            receiver: this.items.UserOrGroupId,
            recType: this.items.RecType,
            isTyping: is_typing,
            IsWeb: 0
          }
          var obj = { method: 'is_typing', data: JSON.stringify(data) }
          bus.$emit('signalr_invokes', JSON.stringify(obj))
          this.current_is_typing = is_typing
        }
      }
    },
    components: {
      InfiniteLoading,
      VueSlickCarousel,
      VuetifyAudio: () => import('vuetify-audio'),
      Emoji,
      Picker
    },

    methods: {
      save_location () {
        this.attach_flag = !this.attach_flag
        var Obj
        this.dialog_location = false
        Obj = { name: 'map', DocUrl: [this.marker._lngLat.lat, this.marker._lngLat.lng], upload: 1 }
        this.files.push(Obj)
      },
      open_map () {
        var self = this
        // init the map
        this.dialog_location = true

        setTimeout(function () {
          self.map_function()

        }, 1000)
      },
      map_function () {
        var self = this
        // self.map.resize()
        if(self.map!=null){
          self.map.remove();
        }
        self.map = new mapboxgl.Map({
          container: 'map2',
          style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
          center: [51.37734351262877, 35.697451890638886],
          zoom: 14 // starting zoom
        })
        self.map.resize()

        self.map.addControl(
          new mapboxgl.GeolocateControl({
            positionOptions: {
              enableHighAccuracy: true
            },
// When active the map will receive updates to the device's location as it changes.
            trackUserLocation: true,
// Draw an arrow next to the location dot to indicate which direction the device is heading.
            showUserHeading: true
          })
        )
        var centro
        self.marker = new mapboxgl.Marker({})
          .setLngLat([0, 0])
          .addTo(self.map)

        self.map.on('drag', function () {
          centro = self.map.getCenter()
          self.user_location_lat = centro.lat
          self.user_location_lng = centro.lng
          self.marker.setLngLat(centro)
        })
        self.map.on('zoom', function () {
          centro = self.map.getCenter()
          self.user_location_lat = centro.lat
          self.user_location_lng = centro.lng
          self.marker.setLngLat(centro)
        })

        self.map.on('load', function () {
          // self.show_polygon();
          self.map.resize()
          centro = self.map.getCenter()
          self.user_location_lat = centro.lat
          self.user_location_lng = centro.lng
          self.marker.setLngLat(centro)
          console.log('map loaded')
          document.getElementsByClassName("mapboxgl-ctrl-top-right")[0].getElementsByClassName("mapboxgl-ctrl-geolocate")[0].classList.add("mapboxgl-ctrl-icon")
        })
      },
      onDragEnd () {
        // var lngLat = marker.getLngLat();
        self.user_location_lat = this.marker.getLngLat().lat
        self.user_location_lng = this.marker.getLngLat().lng
      },
      onDragStart () {
        // var lngLat = marker.getLngLat();
        console.log('drag started')
        self.user_location_lat = this.marker.getLngLat().lat
        self.user_location_lng = this.marker.getLngLat().lng
      },
      ImageOrNot (item) {
        if (item.split('.')[1] == 'jpg' || item.split('.')[1] == 'png' || item.split('.')[1] == 'PNG' || item.split('.')[1] == 'jpeg' || item.split('.')[1] == 'JPEG') {
          return true
        }
      },
      second_human (seconds) {
        var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600)
        var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60)
        var numseconds = (((seconds % 31536000) % 86400) % 3600) % 60
        if (numhours < 10) {
          numhours = '0' + '' + numhours
        }
        if (numminutes < 10) {
          numminutes = '0' + '' + numminutes
        }
        if (numseconds < 10) {
          numseconds = '0' + '' + numseconds
        }
        return numminutes + ':' + numseconds
      },
      startRecording () {
        var self = this

        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          console.log('mediaDevices supported..')

          navigator.mediaDevices.getUserMedia({
            audio: true
          }).then(stream => {
            self.mediaRecorder = new MediaRecorder(stream)

            self.mediaRecorder.ondataavailable = (e) => {
              self.chunks.push(e.data)
            }

            self.mediaRecorder.onstop = () => {
              // const blob = new Blob(self.chunks, {type: 'audio/mp3;codecs=opus'})
              const blob = new Blob(self.chunks, { type: 'audio/ogg' })
              const file = new File([blob], 'recording.ogg')
              self.chunks = []
              self.audioURL = window.URL.createObjectURL(blob)
              // document.querySelector('audio').src = self.audioURL
              // this.attach_flag = !this.attach_flag
              console.log('audio is ', self.audioURL)
              console.log('audio is ', self.recording_time)

              if (self.recording_time > 1) {
                // var blob_file = new File([self.audioURL], "yourfilename.mp3", { type: "audio/mp3"} );
                // const blob_file = new File([self.audioURL], 'audiooo.mp3', {
                //   type: self.audioURL.type,
                // });
                var Obj = { name: 'audio', file: file, DocUrl: self.audioURL, upload: 0, DocType: 5 }
                this.files.push(Obj)
              }
              self.recording_time = 0
              clearTimeout(self.recording_timer)
            }
          }).catch(error => {
            console.log('Following error has occured : ', error)
          })
        } else {
          // stateIndex = ''
          // application(stateIndex)
        }
// mediaRecorder setup for audio
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          console.log('mediaDevices supported..')
          document.getElementById('microphone_record_btn').classList.add('record_button_active')

          navigator.mediaDevices.getUserMedia({
            audio: true
          }).then(stream => {
            self.mediaRecorder.start()
            self.recording_time = 0

            self.run_recording_time()
          }).catch(error => {
            console.log('Following error has occured : ', error)
          })
        } else {
          // application(stateIndex)
        }

        // const addAudio = () => {
        //   const audio = document.createElement('audio')
        //   audio.controls = true
        //   audio.src = audioURL
        //   // display.append(audio)
        // }
      },
      run_recording_time () {
        var self = this
        self.recording_timer = setTimeout(() => {
          self.recording_time += 1
          self.run_recording_time()
        }, 1000)
      },
      stopRecording () {
        var self = this
        document.getElementById('microphone_record_btn').classList.remove('record_button_active')

// mediaRecorder setup for audio
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          console.log('mediaDevices supported..')

          navigator.mediaDevices.getUserMedia({
            audio: true
          }).then(stream => {
            self.mediaRecorder.stop()
          }).catch(error => {
            console.log('Following error has occured : ', error)
          })
        } else {
          // stateIndex = ''
          // application(stateIndex)
        }
      },
      dataURLtoFile (dataurl, filename) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type: mime })
      },
      uploadAttach (index, length, attach) {
        if (attach.upload == 1) {
          console.log('attach[j]', attach)
          attach.upload = 1
          this.rest.push(attach)

          console.log('equal', this.rest)
          this.checkAttachFinish()
        } else {
          var form_data = new FormData()
          var myfile
          console.log('attach aupload', attach)
          if (attach.Caption != 'audio') {
            myfile = this.dataURLtoFile(attach.file, attach.Image_Name)
          } else {
            myfile = attach.file
          }
          // console.log("this.extention(attach[i].Image_Name)",this.extention(attach.Image_Name.split('.')[1]))
          form_data.append('Format', attach.Image_Name.split('.')[1])
          form_data.append('MediaType0', this.extention(attach.Image_Name.split('.')[1]))
          form_data.append('DocType', attach.DocType)
          form_data.append('Upload', myfile)
          console.log('hi')
          var self = this
          this.axios.post('UploadInboxFile', form_data, {})
            .then(response => {
              // console.log("resss", response.data.path)
              // attach[j].DocUrl = response.data.path;
              console.log('attach[j]', attach)
              attach.DocUrl = response.data.path
              attach.upload = 1
              attach.file = null
              self.rest.push(attach)

              // return attach;
              // if(index+1 == length){
              console.log('equal', self.rest)
              self.checkAttachFinish()
              // }
              // self.chat_text = "";
            }).catch(e => {
            // self.errors.push(e);
            console.log('error', e)
          })
        }
      },
      checkAttachFinish () {
        var flag = false
        for (var i = 0; i < this.rest.length; i++) {
          console.log('check', this.rest[i])
          if (this.rest[i].upload == 0) {
            flag = true
          }
        }
        if (flag == false) {
          this.sendSocket(this.rest)
        }
      },
      send_msg () {
        this.showEmojiPicker = false
        this.attach_flag = false
        console.log('send_message file', this.files.length)
        var attach = []

        if (this.files.length > 0) {
          for (var i = 0; i < this.files.length; i++) {
            var x = this.files[i].name
            console.log('tagg', this.files[i])
            if (this.files[i].name == 'map') {
              console.log('map', this.files[i])
              // attach.push({ Caption: this.files[i].name, DocType:this.files[i].DocUrl, upload:this.files[i].upload })
              attach.push({
                Caption: this.files[i].name,
                DocType: 4,
                upload: 1,
                file: this.files[i].DocUrl[0] + '*' + this.files[i].DocUrl[1],
                DocUrl: this.files[i].DocUrl[0] + '*' + this.files[i].DocUrl[1]
              })
            }
            // || this.tagArray[i].includes(".PNG") || this.tagArray[i].includes(".jpeg") || this.tagArray[i].includes(".JPEG")
            else if (this.files[i].name.split('.')[1] == 'jpg' || this.files[i].name.split('.')[1] == 'png' || this.files[i].name.split('.')[1] == 'PNG' || this.files[i].name.split('.')[1] == 'jpeg' || this.files[i].name.split('.')[1] == 'JPEG') {
              console.log('iiiiiiiiiiiimage', this.files[i])
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name,
                DocType: 3,
                upload: 0,
                file: this.files[i].file,
                DocUrl: 'http://zoodbest.com/ZbFiles/UserInboxItems/Images/15122020143730_56893.jpg'
              })
            } else if (this.files[i].name.toLowerCase().includes('.mp3') || this.files[i].name.toLowerCase().includes('.wav') || this.files[i].name.toLowerCase().includes('.ogg')) {
              // this.messages.push('<a href=../assets/image/'+this.tagArray[i]+' download><div class="file-send-format"><span class="file-icon">'+this.tagArray[i]+'</span></div></a>')
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name,
                file: this.files[i].file,
                DocType: 5,
                upload: 0,
                DocUrl: 'http://zoodbest.com/ZbFiles/UserInboxItemsTh45/Images/13032021133805_34656.png'
              })
            } else if (this.files[i].name == 'audio') {
              // this.messages.push('<a href=../assets/image/'+this.tagArray[i]+' download><div class="file-send-format"><span class="file-icon">'+this.tagArray[i]+'</span></div></a>')
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name + '.mp3',
                file: this.files[i].file,
                DocType: 5,
                upload: 0,
                DocUrl: this.files[i].DocUrl
              })
            } else if (this.files[i].name.toLowerCase().includes('.mp4') || this.files[i].name.toLowerCase().includes('.MP4') || this.files[i].name.toLowerCase().includes('.ogg')) {
              // this.messages.push('<a href=../assets/image/'+this.tagArray[i]+' download><div class="file-send-format"><span class="file-icon">'+this.tagArray[i]+'</span></div></a>')
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name,
                DocType: 6,
                upload: 0,
                file: this.files[i].file,
                DocUrl: 'http://zoodbest.com/ZbFiles/UserInboxItemsTh45/Images/13032021133805_34656.png'
              })
            } else if (this.files[i].name.toLowerCase().includes('.pdf') || this.files[i].name.toLowerCase().includes('.docx') || this.files[i].name.toLowerCase().includes('.xlsx') || this.files[i].name.toLowerCase().includes('.txt')) {
              // this.messages.push('<a href=../assets/image/'+this.tagArray[i]+' download><div class="file-send-format"><span class="file-icon">'+this.tagArray[i]+'</span></div></a>')
              attach.push({
                Caption: this.files[i].name,
                Image_Name: this.files[i].name,
                upload: 0,
                file: this.files[i].file,
                DocType: 2,
                DocUrl: 'http://zoodbest.com/ZbFiles/UserInboxItemsTh45/Images/13032021133805_34656.png'
              })
            }
          }
          console.log('send_message', attach.length)
          var rest = []
          for (var j = 0; j < attach.length; j++) {
            this.uploadAttach(j, attach.length, attach[j])

            console.log('return restttt', this.rest)
          }
        } else {
          if (this.chat_text != '') {
            this.sendSocket(attach)
          }
        }
        console.log('sooon')
      },
      sendSocket (attach) {
        console.log('socket')
        // if (this.chat_text != "" ) {
        var user_db = Math.floor((Math.random() * 1000) + 1)
        user_db = user_db * -1
        var message_obj = {
          InboxItemId: 0,
          SubmitDateTime: '',
          userDbId: user_db,
          status: 1,
          SubmitDateTimeMiladi: '',
          UserSenderId: this.UserId,
          UserSenderName: '',
          SourceItem: this.source_sender_id,
          SendStatus: 1,
          SourceText: '',
          SourceSenderName: '',
          SourceSenderId: '',
          UserSenderThumbnail: '',
          ReceiverId: this.items.UserOrGroupId,
          MessageText: this.chat_text,
          Attachments: this.rest,
          Robot: []
        }
        var send_message_obj = {
          userDbId: user_db,
          sender: this.UserId,
          SourceItem: this.source_sender_id,
          sendStatus: 1,
          recType: this.items.RecType,
          SourceText: '',
          SourceSenderName: '',
          SourceSenderId: '',
          receiverId: this.items.UserOrGroupId,
          message: this.chat_text,
          Attachments: this.rest,
        }
        this.files = []
        this.chatLoad.push(message_obj)
        var obj = { method: 'send_message', data: JSON.stringify(send_message_obj) }
        bus.$emit('signalr_invokes', JSON.stringify(obj))
        this.reply_flag = false
        this.source_sender_id = 0
        // }
        this.chat_text = ''
        this.rest = []
        this.files = []
      },
      downloadImage () {
        if (this.isPhotoTaken == true) {
          this.isCameraOpen = false
          // const download = document.getElementById("downloadPhoto");
          const preview = document.getElementById('photoTaken')
          const canvas = document.getElementById('photoTaken').toDataURL('image/jpeg')
          // .replace("image/jpeg", "image/octet-stream");
          console.log('canvas:', canvas)
          var obj = { file: canvas, preview: preview, upload: 0, name: 'myphoto.jpg' }
          this.files.push(obj)
          this.dialog_camera = false
          this.isPhotoTaken = false
          console.log('dwn', obj)
          // this.tagArray.push(obj)
        }
        // download.setAttribute("href", canvas);
      },
      openCamera () {
        this.isCameraOpen = true
        this.createCameraElement()
        this.dialog_camera = true
      },
      takePhoto () {
        this.isPhotoTaken = true
        const context = this.$refs.canvas.getContext('2d')
        context.drawImage(this.$refs.camera, 0, 0, 450, 337.5)
      },
      createAudioElement () {
        try {
          const constraints = (window.constraints = {
            audio: true,
            video: false
          })
          return navigator.mediaDevices.getUserMedia(constraints)
        } catch (err) {
          alert(err)
        }
      },
      createCameraElement () {
        try {
          const constraints = (window.constraints = {
            audio: false,
            video: true
          })

          navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
              this.$refs.camera.srcObject = stream
            })
            .catch(error => {
              alert('notSupportCamera')
            })
        } catch (err) {
          alert(err)
        }
      },
      deleteTag (item) {
        console.log('delete')
        this.files.splice(this.files.indexOf(item), 1)
        if (this.files.length == 0) {
          this.tagFlag = false
        }
      },
      onFileChange (name) {
        this.attach_flag = !this.attach_flag
        // var files = e.target.files || e.dataTransfer.files;
        var self = this

        if (name == 'file') {
          var reader = new FileReader()
          var f = document.getElementById('fileUpload').files

          if (f[0].name.toLowerCase().includes('.pdf') || f[0].name.toLowerCase().includes('.docx') || f[0].name.toLowerCase().includes('.xlsx') || f[0].name.toLowerCase().includes('.txt') || f[0].name.toLowerCase().includes('.wav') || f[0].name.toLowerCase().includes('.mp3') || f[0].name.toLowerCase().includes('.mp4') || f[0].name.toLowerCase().includes('.MP4') || f[0].name.toLowerCase().includes('.ogg') || f[0].name.toLowerCase().includes('.jpg') || f[0].name.toLowerCase().includes('.png') || f[0].name.toLowerCase().includes('.PNG') || f[0].name.toLowerCase().includes('.jpeg') || f[0].name.toLowerCase().includes('.JPEG')) {
            console.log('file')
            reader.onloadend = function () {
              var obj = { file: reader.result, preview: reader.result, upload: 0, name: f[0].name }
              self.files.push(obj)
            }
            reader.readAsDataURL(f[0])
            console.log('111', self.files)
            // this.tagArray.push(f[0].name)
            // console.log("files", this.tagArray);
            this.tagFlag = true
            if (!self.files.length) {
            }
          }
        }
      },
      open_camera_input () {
        document.getElementById('fileUploadCamera').click()
      },
      onFileChangeCamera (name) {
        this.attach_flag = !this.attach_flag
        // var files = e.target.files || e.dataTransfer.files;
        var self = this

        if (name == 'file') {
          var reader = new FileReader()
          var f = document.getElementById('fileUploadCamera').files

          if (f[0].name.toLowerCase().includes('.pdf') || f[0].name.toLowerCase().includes('.docx') || f[0].name.toLowerCase().includes('.xlsx') || f[0].name.toLowerCase().includes('.txt') || f[0].name.toLowerCase().includes('.wav') || f[0].name.toLowerCase().includes('.mp3') || f[0].name.toLowerCase().includes('.mp4') || f[0].name.toLowerCase().includes('.MP4') || f[0].name.toLowerCase().includes('.ogg') || f[0].name.toLowerCase().includes('.jpg') || f[0].name.toLowerCase().includes('.png') || f[0].name.toLowerCase().includes('.PNG') || f[0].name.toLowerCase().includes('.jpeg') || f[0].name.toLowerCase().includes('.JPEG')) {
            console.log('file')
            reader.onloadend = function () {
              var obj = { file: reader.result, preview: reader.result, upload: 0, name: f[0].name }
              self.files.push(obj)
            }
            reader.readAsDataURL(f[0])
            console.log('111', self.files)
            // this.tagArray.push(f[0].name)
            // console.log("files", this.tagArray);
            this.tagFlag = true
            if (!self.files.length) {
            }
          }
        }
      },
      openAttach () {
        this.attach_flag = !this.attach_flag
      },
      openLink (type, link) {
        if (type == 1) {
          console.log('link ', link)
          window.open(link, '_blank')
        }
        if (type == 6) {
          window.open(link, '_blank')
        }
        if (type == 2) {
          window.open(link, '_blank')
        }
        if (type == 4) {
          link = link.split('*')
          link = 'https://www.google.com/maps/search/?api=1&query=' + link
          window.open(link, '_blank')
        }
      },
      openVideo () {

      },
      closeClick () {
        this.showEmojiPicker = false
        this.attach_flag = false
      },
      openImg (item) {
        this.dialog = true
        this.open_image = item
        console.log('open')
      },
      openMap (item) {
        window.open("https://www.google.com/maps?q="+item.split("*")[0]+","+item.split("*")[1]+"&z=17&hl=en")
      },
      copyMsg (e) {
        var text_id = 'chat_text_' + this.last_select_index
        console.log('text_id', text_id)
        var copyText = document.getElementById(text_id)
        var input = document.body.appendChild(document.createElement('input'))
        input.value = copyText.textContent
        // input.focus();
        input.select()
        document.execCommand('copy')

        console.log('Copied the text: ' + copyText.textContent)
        input.setAttribute('type', 'hidden')
      },
      reply () {
        console.log('reply chat: ', this.show_detail)
        this.reply_flag = true
        this.source_sender_id = this.show_detail.InboxItemId
        this.reply_item = this.show_detail
      },
      checkOneClick (e, item, i) {
        // this.show_detail = item;
        this.last_select_index = i
        var myNode = e.srcElement.attributes[0].nodeValue
        console.log('eventt:', e.srcElement.attributes[0].nodeValue)
        if (this.selectedItem.length == 0) {
          if (myNode == 'inner' || myNode == 'my-message' || myNode == 'deliver' || myNode == 'my-message fully' || myNode == 'your-message' || myNode == 'your-message fully') {
            e.preventDefault()
            this.showMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.show_detail = item
            this.$nextTick(() => {
              this.showMenu = true
              this.hide_menu = true
            })
          }
        } else {
          // console.log("before selected");
          this.selectChat(item, i)
        }
      },
      longClick (e, chat, i) {
        this.show_detail = chat
        e.preventDefault()
        // console.log("long");
        this.selectChat(chat, i)
      },
      replySelected () {
        console.log('reply')
      },
      forwardSelected () {
        console.log('forward')
        this.$router.push({ path: '/message-tab', params: {} })
        localStorage.setItem('lastForward', JSON.stringify(this.selectedItem))
      },
      deleteSelected () {

      },
      selectChat (chat, i) {
        this.selectedItem = []
        var cnt = 0
        if (chat.IsSelected == false) {
          chat.IsSelected = true
          this.chatLoad.splice(i, 1, chat) // replace it
        } else {
          chat.IsSelected = false
          this.chatLoad.splice(i, 1, chat)
        }
        for (var j = 0; j < this.chatLoad.length; j++) {
          if (this.chatLoad[j].IsSelected == true) {
            this.selectedItem.push(this.chatLoad[j])
            cnt++
          }
        }
        if (cnt == 1) {
          this.show_detail = this.selectedItem[0]

          this.header_reply = true
        } else {
          this.header_reply = false
          this.show_detail = chat
        }
        if (this.selectedItem.length > 0) {
          this.appear_name = false
        } else {
          this.appear_name = true
        }
        // console.log(cnt)
        //
        console.log('this.selectedItem ', this.selectedItem)
      },
      extention (file_extention) {
        var x = file_extention.toLowerCase()
        if (x == 'aac') return 'audio/aac'
        if (x == 'ogg') return 'audio/aac'
        if (x == 'avi') return 'video/x-msvideo'
        if (x == 'doc') return 'application/msword'
        if (x == 'docx') return 'application/vnd'
        if (x == 'jpg') return 'image/jpeg'
        if (x == 'jpeg') return 'image/jpeg'
        if (x == 'gif') return 'image/gif'
        if (x == 'mpeg') return 'video/mpeg'
        if (x == 'png') return 'image/png'
        if (x == 'pdf') return 'application/pdf'
        return 'nothing'
      },

      addEmoji (emoji) {
        const text = emoji.native
        // console.log("emojii",'<emoji emoji="'+ text +'" set="emojione" :size="16" />' )
        // console.log("text", emoji )
        this.emojies = '<emoji emoji="' + text + '" set="emojione" :size="16" />'

        this.chat_text = this.chat_text + text
        // this.$emit('input', text)
        // textarea.focus()
        // this.$nextTick(() => {
        //   textarea.selectionEnd = cursorPosition + emoji.native.length
        // })
      },
      toggleEmojiPicker () {
        this.showEmojiPicker = !this.showEmojiPicker
      },
      goToInfo (item) {
        const last_user_info = {
          RecType: item.RecType,
          UserOrGroupId: item.UserOrGroupId
        }
        localStorage.setItem('LastUserInfo', JSON.stringify(last_user_info))
        this.$router.push({ path: '/contact-info', params: {} })
      },
      infiniteHandler ($state) {
        var self = this
        // console.log("first is "+ this.first);
        if (this.first) {
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        } else {
          console.log('not first')
        }

        // console.log("self.chatLoad[0] ", self.chats.length)

        // console.log("hiii"+ self.chatLoad[0].InboxItemId)
        if (self.chats.length > 0) {
          setTimeout(() => {
            self.lastMessageId = self.chatLoad[0].InboxItemId
            self.loadChats($state)
          }, 1000)
        } else {
          $state.complete()
        }
      },
      backToChats () {
        // this.$router.push({ path: '/dashboard', params: {} })
        this.$router.go(-1)
      },
      loadChats ($state) {
        const send_data = {
          ReceiverId: this.items.UserOrGroupId,
          UserId: this.UserId,
          RecType: this.items.RecType,
          LastMessageId: this.lastMessageId,
          Password: this.password,
        }
        // for(var i=0; i<this.forward_message.length ;i++){
        //   if(this.forward_message[i].IsSelected == true){
        //     this.forward_message[i].IsSelected = false;
        //   }
        // }
        console.log('forward_message', this.forward_message)

        var self = this
        this.axios.post('/LoadContactChats', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response edit", response.data.messages);
              self.date_now = response.data.dateNow
              self.chats = response.data.messages
              for (var i = 0; i < self.chats.length; i++) {
                if (response.data.maxReadId >= self.chats[i].InboxItemId) {
                  self.chats[i].status = 10
                } else {
                  self.chats[i].status = 5
                }

                self.chats[i].IsSelected = false
                if (self.chats[i].Attachments.length != 0) {
                  for (var j = 0; j < self.chats[i].Attachments.length; j++) {
                    var mySplit = self.chats[i].Attachments[j].DocUrl.split('/')
                    this.split_result = mySplit[mySplit.length - 1]
                    self.chats[i].Attachments[j].Image_Name = mySplit[mySplit.length - 1]
                  }
                }
              }
              self.chats.reverse()
              if (self.first) {
                self.first = false
                // self.infiniteHandler()
                self.chatLoad = self.chats
              } else {
                // console.log("self.chatLoad:" + JSON.stringify(self.chatLoad[0]))
                self.chats.reverse()
                for (var i = 0; i < self.chats.length; i++) {
                  self.chatLoad.splice(0, 0, self.chats[i])
                }
              }
              if ($state != null) {
                if (self.chats.length > 0) {
                  $state.loaded()
                } else {
                  $state.complete()
                }
              }
              var data = {
                ReceiverId: this.UserId,
                SenderId: this.items.UserOrGroupId,
                LastItemId: self.chats[self.chats.length - 1].InboxItemId
              }
              var obj = { method: 'send_read', data: JSON.stringify(data) }
              bus.$emit('signalr_invokes', JSON.stringify(obj))
            }
          })
          .catch(e => {

          })
        console.log('this.forward_message', this.forward_message)
        if (this.forward_message != null) {
          for (var i = 0; i < this.forward_message.length; i++) {
            if (this.forward_message[i].IsSelected == true) {
              this.forward_message[i].IsSelected = false
            }
            this.chatLoad.push(this.forward_message[i])
          }
        }
        // if(this.forward_message != null){
        //   // this.forward_message = JSON.parse(this.forward_message);
        //   for(var i=0 ;i< this.forward_message.length;i++) {
        //     this.chatLoad.push(this.forward_message[i])
        //   }
        // }
      },
      getUserInfo () {
        const send_data = {
          UserId: this.items.UserOrGroupId
        }
        var self = this
        this.axios.post('/GetUserInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("user info" , response.data.userInfo)
              self.user_info = response.data.userInfo
            }
          }).catch(e => {

        })
      },
      getGroupInfo () {
        // console.log("get group info")
        const send_data = {
          UserId: this.UserId,
          GroupId: this.items.UserOrGroupId
        }
        var self = this
        this.axios.post('/GetGroupInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("user info" , response.data.userInfo)
              self.user_info = response.data.userInfo
            }
          }).catch(e => {

        })
      },
      scrollToEnd () {
        var container = this.$el.querySelector('#chat_detail')
        var pageHeight = container.scrollHeight
        container.scrollTop = pageHeight
        // console.log("end" + container.scrollHeight)
      },
      convert_string_to_date (date) {
        var dateString = date

        var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/
        var dateArray = reggie.exec(dateString)

        // var date = dateArray[3]+"-"+dateArray[2]+"-"+dateArray[1]+"T00:00:00.000+03:30"
        try {
          var dateObject = new Date(
            (+dateArray[3]),
            (+dateArray[2]), // Careful, month starts at 0!
            (+dateArray[1]),
            (+dateArray[4]),
            (+dateArray[5]),
            (+dateArray[5])
          )
          return dateObject.toDateString()
        } catch (e) {
          return ''
        }
      },
      get_conversation_date (item) {
        var date = item.SubmitDateTimeMiladi
        date = date.replace('  ', ' ')
        var days = 0
        var dateNow = new Date(this.convert_string_to_date(this.date_now))
        var conv_date = new Date(this.convert_string_to_date(date))
        // var conv_date_hour2 = new Date(item.SubmitDateTime)

        var reportDate = item.SubmitDateTime.substring(11)
        // console.log(item)
        days = dateNow - conv_date

        days = days / (1000 * 60 * 60 * 24)

        var ret
        if (days < 1) {
          ret = reportDate
        } else if (days >= 1 && days < 2) {
          ret = this.$t('yesterday') + reportDate
        } else if ((days < 8) && (days > 1)) {
          ret = days + this.$t('dayBefor') + reportDate
        } else {
          ret = item.SubmitDateTime
        }

        return ret
      },
    },
  }
</script>
<style lang="scss" scoped>
  .basemap {
    width: 100%;
    height: 500px;
  }
</style>
